import * as Bixby from '$/core';

export abstract class ReleaseFeatureFlagsService {
  private static baseUrl = `${Bixby.Constants.API_RELEASEFEATUREFLAGCONTROLLER}`;

  public static async getAll(): Promise<Bixby.Models.ReleaseFeatureFlag[]> {
    const route = Bixby.API.ServerRoute.forAction(ReleaseFeatureFlagsService.baseUrl);
    return await Bixby.API.get(route);
  }
}
